/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActionAudDtoFromJSON, ActionAudDtoToJSON, } from './ActionAudDto';
/**
 * Check if a given object implements the ActionAudPagedDto interface.
 */
export function instanceOfActionAudPagedDto(value) {
    return true;
}
export function ActionAudPagedDtoFromJSON(json) {
    return ActionAudPagedDtoFromJSONTyped(json, false);
}
export function ActionAudPagedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'actionAudDtoList': json['actionAudDtoList'] == null ? undefined : (json['actionAudDtoList'].map(ActionAudDtoFromJSON)),
        'size': json['size'] == null ? undefined : json['size'],
        'page': json['page'] == null ? undefined : json['page'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}
export function ActionAudPagedDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'actionAudDtoList': value['actionAudDtoList'] == null ? undefined : (value['actionAudDtoList'].map(ActionAudDtoToJSON)),
        'size': value['size'],
        'page': value['page'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}
